(() => {
  if (window.IndianShelfCardQuantityReady) return;
  window.IndianShelfCardQuantityReady = true;

  const getInput = (button) => button.closest('[data-card-qty]')?.querySelector('.indianshelf-card-qty__input');

  const normalize = (input) => {
    const min = Number.parseInt(input.getAttribute('min') || '1', 10);
    const max = Number.parseInt(input.getAttribute('max') || '', 10);
    let value = Number.parseInt(input.value || `${min}`, 10);

    if (Number.isNaN(value) || value < min) value = min;
    if (!Number.isNaN(max) && value > max) value = max;

    input.value = `${value}`;
    return value;
  };

  document.addEventListener('click', (event) => {
    const minus = event.target.closest('[data-qty-minus]');
    const plus = event.target.closest('[data-qty-plus]');
    const button = minus || plus;

    if (!button) return;

    const input = getInput(button);
    if (!input) return;

    event.preventDefault();

    const current = normalize(input);
    const next = plus ? current + 1 : current - 1;
    input.value = `${next}`;
    normalize(input);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('input', (event) => {
    if (event.target.matches('.indianshelf-card-qty__input')) {
      normalize(event.target);
    }
  });
})();
